import React from 'react';
import LazyPageLoader from 'js/LazyPageLoader.js';

const importer = ()=>{

};
export default [
    {
        routesToLocation : ( location  )=>{
            return  ( location.pathname.indexOf('/a/register') === 0 || location.pathname.indexOf('/register') === 0);
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/RegisterPage/RegisterPageLoader.js')  ;} ,  location , changeUpdater  , startupData  );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'RegisterPage' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return   location.pathname == '/'   ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader (  ()=>{return import( /* webpackMode:  "lazy-once" */  'js/PageLoaders/Redirect.js')  ;} ,  location , changeUpdater  , {...startupData , toLocation : '/a/me/dashboard' } );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'WebsiteHomepage' ;
        }
    },
      {
        routesToLocation : ( location  )=>{
            return   location.pathname == '/oauth/authorize'   ;
            
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader (  ()=>{return import( /* webpackMode:  "lazy-once" */  'js/Pages/OauthAuthorization/OauthAuthorizationPagePageLoader.js')  ;} ,  location , changeUpdater  , {...startupData , toLocation : '/oauth/authorize' } );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'oauth-authorization' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/chats[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return  import( /* webpackMode:  "lazy-once" */  'js/Pages/ChatsPage/ChatsPageLoader.js')  ;}  ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => { 
            return moduleName.toLowerCase().trim() == 'ChatsPage' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/account-manager-invites\/[a-zA-Z0-9]+[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return  import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountManagerInviteRedeem/AccountManagerInviteRedeemPageLoader.js')  ;}  ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/AccountManagerInviteRedeem' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/add-manager[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return  import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountManagers/AddManagerPage/AddManagerPageLoader.js')  ;}  ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/Addmanager' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/avatar[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return  import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountSettings/AccountAvatarPage/AccountAvatarPageLoader.js')  ;}  ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/Settings/Avatar' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/managers[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return  import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountManagers/AccountManagersPageLoader.js')  ;}  ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/Managers' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/settings[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountSettings/AccountSettingsPageLoader.js') ;}  ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/Settings' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/create-order[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountOrders/AccountCreateOrderPageLoader.js') ;}  ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/CreateOrder' ;
        }
    },
    
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/sample-approvals[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/SampleApprovals/SampleApprovalsPageLoader.js')  ;} ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/SampleApprovals' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/sample-approvals\/[a-zA-Z0-9]+[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/SampleApproval/SampleApprovalPageLoader.js')  ;} ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/SampleApproval' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/orders\/[a-zA-Z0-9]+[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/OrderPage/OrderPageLoader.js')  ;} ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/Order' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/orders[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader (  ()=>{return import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountOrders/AccountOrdersPageLoader.js') ;}  ,  location , changeUpdater  ,  startupData   );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/Orders' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountDashboard/AccountDashboardPageLoader.js')  ;} ,  location , changeUpdater  , {...startupData , toLocation : '/a/me/dashboard' } );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'AccountDashboard' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/developer-apps[\/]?$/g)  !== null     ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/DeveloperApps/DeveloperAppsPagePageLoader.js')  ;} ,  location , changeUpdater  ,  startupData );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'DeveloperApps/DeveloperApps' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/developer-apps(\/[a-zA-Z0-9]+)?\/?$/) !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/DeveloperAppDashboard/DeveloperAppDashboardPagePageLoader.js')  ;} ,  location , changeUpdater  ,  startupData );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/DeveloperAppDashboard/DeveloperAppDashboard' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname == '/a/me/accounts' ||  location.pathname == '/a/me/accounts/'  ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader (  ()=>{return import( /* webpackMode:  "lazy-once" */  'js/Pages/User/AccountsOverviewPage/AccountsOverviewPageLoader.js') ;}  ,  location , changeUpdater  , {...startupData , toLocation : '/a/me/dashboard' } );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'WebsiteHomepage' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return   location.pathname == '/a' ||  location.pathname == '/a/'|| location.pathname == '/a/me' ||  location.pathname == '/a/me/'   ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/PageLoaders/Redirect.js')  ;} ,  location , changeUpdater  , {...startupData , toLocation : '/a/me/dashboard' } );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'AppIndexPage' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return   location.pathname.indexOf('/a/forgot-password') === 0    ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/User/ForgotPasswordPage/ForgotPasswordPageLoader.js')  ;} ,  location , changeUpdater  ,  startupData    );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'CreateAccountPage' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return   location.pathname.indexOf('/a/create-company-account') === 0    ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/CreateAccount/CreateAccountPageLoader.js')  ;} ,  location , changeUpdater  ,  startupData    );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'CreateAccountPage' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/\/a\/ac\/[a-zA-Z0-9]+\/company-name[\/]?$/g)  !== null;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/Account/AccountSettings/AccountNamePage/AccountNamePageLoader.js')  ;} ,  location , changeUpdater  ,  startupData    );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'Account/CompanyName' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return   location.pathname.indexOf('/a/me/change-password') === 0    ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/ChangePasswordPage/ChangePasswordPageLoader.js')  ;} ,  location , changeUpdater  ,  startupData    );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/ChangePassword' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return   location.pathname.indexOf('/a/me/change-fullname') === 0    ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/UserDetails/UserFullnameEditPageLoader.js')  ;} ,  location , changeUpdater  ,  startupData    );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/Details/ChangeFullname' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return   location.pathname.indexOf('/a/me/display-language') === 0    ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/UserDetails/UserDisplayLanguagePage.js')  ;} ,  location , changeUpdater  ,  startupData    );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/Details/DisplayLanguage' ;
        }
    },

    {
        routesToLocation : ( location  )=>{
            return   location.pathname.indexOf('/a/me/dashboard') === 0    ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader (  ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/User/Dashboard/DashboardPageLoader.js') ;}  ,  location , changeUpdater  ,  startupData    );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/Dashboard' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return   location.pathname.indexOf('/a/me/change-email') === 0     ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData  , appReducer ) => {
            return new LazyPageLoader (  ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/ChangeEmail/ChangeEmailPageLoader.js') ;}  ,  location , changeUpdater  ,  startupData   , appReducer  );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/ChangeEmail' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/^\/a\/me\/security\/multifactor[\/]?$/g);
        },
        getPageLoaderModule : ( location , changeUpdater , startupData  , appReducer ) => {
            return new LazyPageLoader (  ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/UserDetails/Auth/MultiFactorPage/MultiFactorPageLoader.js') ;}  ,  location , changeUpdater  ,  startupData   , appReducer  );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/Auth/Multifactor' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/^\/a\/me\/security\/email-otp[\/]?$/g);
        },
        getPageLoaderModule : ( location , changeUpdater , startupData  , appReducer ) => {
            return new LazyPageLoader (  ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/UserDetails/AuthIdentity/EmailOtp/EmailOtpPageLoader') ;}  ,  location , changeUpdater  ,  startupData   , appReducer  );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/Auth/EmailOtp' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.match(/^\/a\/me\/security\/totp[\/]?$/g);
        },
        getPageLoaderModule : ( location , changeUpdater , startupData  , appReducer ) => {
            return new LazyPageLoader (  ()=>{ return import( /* webpackMode:  "lazy-once" */  'js/Pages/UserDetails/AuthIdentity/Totp/TotpPageLoader') ;}  ,  location , changeUpdater  ,  startupData   , appReducer  );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/Auth/Totp' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return location.pathname.indexOf('/a/me/security') === 0 ||  location.pathname.indexOf('/a/me/general') === 0 || location.pathname.indexOf('/a/me/settings') === 0 || location.pathname.match(/^\/a\/me\/security[\/]?$/g);
        },
        getPageLoaderModule : ( location , changeUpdater , startupData  , appReducer) => {
            return new LazyPageLoader ( ()=>{ return  import( /* webpackMode:  "lazy-once" */  'js/Pages/UserDetails/UserDetailsPageLoader.js') ;}  ,  location , changeUpdater  ,  startupData   , appReducer  );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'User/UserDetails' ;
        }
    },
    {
        routesToLocation : ( location  )=>{
            return  ( location.pathname.indexOf('/a/login') === 0 || location.pathname.indexOf('/login') === 0);
        },
        getPageLoaderModule : ( location , changeUpdater , startupData ) => {
            return new LazyPageLoader ( ()=>{ return  import( /* webpackMode:  "lazy-once" */  'js/Pages/LoginPage/LoginPageLoader.js')  ;} ,  location , changeUpdater  , startupData );
        },
        routesToModuleNameString : (moduleName) => {
            return moduleName.toLowerCase().trim() == 'LoginPage' ;
        }
    },
    {
        // name : 'fallback' ,
        routesToLocation : ( location   )=>{
            return true ;
        },
        getPageLoaderModule : ( location , changeUpdater , startupData  ) => {
            return new LazyPageLoader ( ()=>{ return import(/* webpackMode:  "lazy-once" */'js/Pages/FallbackPageLoader.js') ;} ,  location , changeUpdater  , startupData );
        },
        routesToModuleNameString : (moduleName) => {
            return true ;
        }
    } ,
    // {
    //     // name : 'winkelwagen' ,
    //     routesToLocation : ( location   )=>{
    //         return location.pathname.indexOf( '/winkelwagen') !== -1 ;
    //     },
    //     getPageLoaderModule : ( location , changeUpdater , startupData  ) => {
    //         return new LazyPageLoader ( import(/* webpackMode:  "weak" */ 'js/Pages/Cart/CartPageLoader.js').catch( () => {  return import(/* webpackMode:  "lazy" */ 'js/Pages/Cart/CartPageLoader.js') }) ,  location , changeUpdater  , startupData );
    //     },
    //     routesToModuleNameString : (moduleName) => {
    //         return moduleName.toLowerCase().trim() == 'cart' ;
    //     }
    // },
    // {
    //     // name : 'OrderPayments' ,
    //     routesToLocation : ( location   )=>{
    //         return ( location.pathname.match(/\/orders\/[a-zA-Z0-9]+\/payments/g)  !== null || location.pathname.match(/\/o\/[a-zA-Z0-9]+\/p/g)  !== null ) ;
    //     },
    //     getPageLoaderModule : ( location , changeUpdater , startupData  ) => {
    //         return new LazyPageLoader ( import(/* webpackMode:  "lazy-once" */'js/Pages/OrderPayments/OrderPaymentsPageLoader.js') ,  location , changeUpdater  , startupData );
    //     },
    //     routesToModuleNameString : (moduleName) => {
    //         return moduleName.toLowerCase().trim() == 'orderpayments' ;
    //     }
    // },
    // {
    //     // name : 'fallback' ,
    //     routesToLocation : ( location   )=>{
    //         return true ;
    //     },
    //     getPageLoaderModule : ( location , changeUpdater , startupData  ) => {
    //         return new LazyPageLoader ( import(/* webpackMode:  "lazy-once" */'js/Pages/FallbackPageLoader.js') ,  location , changeUpdater  , startupData );
    //     },
    //     routesToModuleNameString : (moduleName) => {
    //         return true ;
    //     }
    // } ,


];
